import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "timeToImpression", "options", "sx", "onCreateImpression"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box } from '@hub/box';
import React from 'react';
import { useImpressionObserver } from '@scentregroup/analytics';
import { jsx as _jsx } from "react/jsx-runtime";
// TODO Consolidate this with AnalyticsImpressionTracker
// from analytics-observer/index.tsx
const ImpressionTracker = _ref => {
  let {
      children,
      timeToImpression,
      options,
      sx,
      onCreateImpression: onCreateImpressionWhenView
    } = _ref,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  const {
    inViewRef
  } = useImpressionObserver({
    timeToImpression,
    options,
    onCreateImpressionWhenView
  });
  return /*#__PURE__*/_jsx(Box, {
    sx: sx,
    ref: inViewRef,
    "data-id": "impression-tracker_index_ImpressionTracker_Box",
    children: /*#__PURE__*/React.cloneElement(children, _objectSpread(_objectSpread({}, children.props), extraProps))
  });
};
export default ImpressionTracker;